import React, { FC, ReactNode } from "react";

import AmbassadorNavbar from "../../navbar/AmbassadorNavbar";
import AmbassadorFooter from "../../footer/AmbassadorFooter";

interface Props {
  children: ReactNode;
}

const AmbassadorLayout: FC<Props> = ({ children }) => {
  return (
    <div>
      <AmbassadorNavbar />
      <div className="page-container">{children}</div>
      <AmbassadorFooter />
    </div>
  );
};

export default AmbassadorLayout;
